import { render, staticRenderFns } from "./CompetitorWarning.vue?vue&type=template&id=5eacdece&scoped=true"
import script from "./CompetitorWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitorWarning.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eacdece",
  null
  
)

export default component.exports